import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import Layout from '../components/layout';
import {
	Container,
	Content,
	Section,
	SectionTitle,
	ContactButton,
	ContactButton2,
	BrochureButton,
	FeatureCard,
	FeatureNumber,
	FeatureTitle,
	FeatureDescription,
	FeatureNote,
	FeatureImage,
} from '../components/styled';
import useSizeDetector from '../hooks/useSizeDetector';

import TopBackgroundImg from '../assets/images/reviewaid/top_background.png';
import TopLogoImg from '../assets/images/reviewaid/top_logo.png';
import TopReviewaidImg from '../assets/images/reviewaid/top_reviewaid.png';
import Section2BackgroundImg from '../assets/images/reviewaid/section2_background.png';
import Section2ButtonArrowImg from '../assets/images/reviewaid/section2_button_arrow.png';
import MobileSection2BackgroundImg from '../assets/images/reviewaid/mobile_section2_background.png';
import MobileSection2ButtonArrowImg from '../assets/images/reviewaid/mobile_section2_button_arrow.png';
import Section3Feature1Img from '../assets/images/reviewaid/section3_feature1.png';
import Section3Feature2Img from '../assets/images/reviewaid/section3_feature2.png';
import Section3Feature3Img from '../assets/images/reviewaid/section3_feature3.png';
import Section4Feature1Img from '../assets/images/reviewaid/section4_feature1.png';
import Section4Feature2Img from '../assets/images/reviewaid/section4_feature2.png';
import Section4Feature3Img from '../assets/images/reviewaid/section4_feature3.png';
import MobileSection3Feature1Img from '../assets/images/reviewaid/mobile_section3_feature1.png';
import MobileSection3Feature2Img from '../assets/images/reviewaid/mobile_section3_feature2.png';
import MobileSection3Feature3Img from '../assets/images/reviewaid/mobile_section3_feature3.png';
import MobileSection4Feature1Img from '../assets/images/reviewaid/mobile_section4_feature1.png';
import MobileSection4Feature2Img from '../assets/images/reviewaid/mobile_section4_feature2.png';
import MobileSection4Feature3Img from '../assets/images/reviewaid/mobile_section4_feature3.png';

import ChannelService from '../components/channel';

const Reviewaid = () => {
	const { isDesktop, Desktop, Mobile } = useSizeDetector();
	const [ready, setReady] = useState(false);
	useEffect(() => {
		setReady(true);
        ChannelService.boot({
          "pluginKey": "f16b2776-23fb-4736-859f-5cf88f46832e"
        });
	}, []);

	return (
		ready && (
			<Layout>
				<Helmet>
					<meta property="og:type" content="website" />
					<meta property="og:url" content="https://www.onmydev.com/reviewaid" />
					<meta property="og:title" content="리뷰에이드 | 고객 리뷰, 자랑할 때입니다." />
					<meta property="og:image" content="https://s3.ap-northeast-2.amazonaws.com/cdn.atsent.ai/reviewaid.png" />
					<meta property="og:description" content="AI가 고객리뷰를 요약해 멋지게 보여줍니다." />
					<meta property="og:site_name" content="리뷰에이드" />
					<meta property="og:locale" content="ko_KR" />

                    <meta name="title" content="리뷰에이드 | 고객 리뷰, 자랑할 때입니다." />
                    <meta name="author" content="onmydev" />
                    <meta name="keywords" content="온마이뎁,리뷰에이드,reviewaid,리뷰,리뷰 솔루션" />
                    <meta name="description" content="AI가 고객리뷰를 요약해 멋지게 보여줍니다." />
                    <meta property="twitter:domain" content="www.onmydev.com" />
                    <meta property="twitter:url" content="https://www.onmydev.com/reviewaid" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="리뷰에이드 | 고객 리뷰, 자랑할 때입니다." />
                    <meta name="twitter:description" content="AI가 고객리뷰를 요약해 멋지게 보여줍니다." />
                    <meta name="twitter:image" content="https://s3.ap-northeast-2.amazonaws.com/cdn.atsent.ai/reviewaid.png" />

					<meta charset="utf-8" />
					<title>리뷰에이드 | 고객 리뷰, 자랑할 때입니다.</title>
					<link rel="canonical" href="https://www.onmydev.com/reviewaid" />
					<link rel="shortcut icon" href="/favicon_reviewaid.ico" />
					<link rel="icon" type="image/png" href="/favicon_reviewaid-16x16.png" sizes="16x16" />
					<link rel="icon" type="image/png" href="/favicon_reviewaid-32x32.png" sizes="32x32" />
					<link rel="icon" type="image/png" href="/favicon_reviewaid-96x96.png" sizes="96x96" />
				</Helmet>
				<Container>
					<Section backgroundImage={TopBackgroundImg}>
						<Content>
							<TopCarouselTitle>
								<Desktop>고객을 만드는 감성 리뷰 마케팅 솔루션</Desktop>
								<Mobile>
									고객을 만드는
									<br />
									감성 리뷰 마케팅 솔루션
								</Mobile>
							</TopCarouselTitle>
							<TopLogo src={TopLogoImg} />
							<TopButtonContainer>
								<TopButton onClick={() => window.open('https://store.cafe24.com/kr/apps/14778')}>카페24에서 시작하기</TopButton>
								<TopButton onClick={() => window.open('https://reviewaid.channel.io/lounge')}>문의하기</TopButton>
							</TopButtonContainer>
							<TopReviewaid src={TopReviewaidImg} />
						</Content>
					</Section>
					<Section backgroundImage={isDesktop ? Section2BackgroundImg : MobileSection2BackgroundImg}>
						<Content>
							<SectionTitle color={'white'}>
								90%의 고객이 상품 구매 시<br />
								<StyledSpan color={'#4BA4F8'}>긍정적인 리뷰</StyledSpan>에 영향을 받습니다
							</SectionTitle>
							<Section2ButtonContainer>
								<Section2Button>
									리뷰 수<Section2ButtonArrow />
								</Section2Button>
								<Section2Button>
									긍정 리뷰
									<Section2ButtonArrow />
								</Section2Button>
								<Section2Button>
									매출 증가
									<Section2ButtonArrow />
								</Section2Button>
							</Section2ButtonContainer>
							<SectionTitle color={'white'}>
								<Desktop>
									리뷰,
									<br />좀 더 효과적으로 사용할 수 있지 않을까요?
								</Desktop>
								<Mobile>
									리뷰, 좀 더 효과적으로
									<br />
									사용할 수 있지 않을까요?
								</Mobile>
							</SectionTitle>
						</Content>
					</Section>
					<Section paddingBottom={isDesktop ? '' : '88px'}>
						<Content>
							<SectionTitle>
								고객의 목소리로 새로운 고객을 만드는
								<br />
								바이럴 마케팅 온사이트 배너 리뷰에이드
							</SectionTitle>
							<FeatureContainer>
								<FeatureCard>
									<FeatureNumber>01</FeatureNumber>
									<FeatureTitle>한 줄 요약 리뷰</FeatureTitle>
									<FeatureDescription>
										<Desktop>
											가장 긍정적인 요소를 골라 수치와 함께 요약해드립니다!
											<br />
											고객은 필요한 정보를 쉽게 얻고, 더 빠른 구매 결정을 내립니다.
										</Desktop>
										<Mobile>
											가장 긍정적인 요소를 골라
											<br />
											수치와 함께 요약해드립니다!
											<br />
											고객은 필요한 정보를 쉽게 얻고
											<br />더 빠른 구매 결정을 내립니다.
										</Mobile>
									</FeatureDescription>
									<FeatureNote>*3가지 긍정 요소까지 롤링이 가능합니다.</FeatureNote>
									<FeatureImage
										src={isDesktop ? Section3Feature1Img : MobileSection3Feature1Img}
										shadow
									/>
								</FeatureCard>
								<FeatureCard>
									<FeatureNumber>02</FeatureNumber>
									<FeatureTitle>핵심 요소</FeatureTitle>
									<FeatureDescription>
										<Desktop>
											긍정적인 리뷰가 많은 요소를 최대 8개까지 노출합니다!
											<br />
											고객은 자신이 원하는 요소의 긍정 비율을 빠르게 파악합니다.
										</Desktop>
										<Mobile>
											긍정적인 리뷰가 많은 요소를
											<br />
											최대 8개까지 노출합니다!
											<br />
											고객은 자신이 원하는 요소의
											<br />
											긍정 비율을 빠르게 파악합니다.
										</Mobile>
									</FeatureDescription>
									<FeatureImage
										src={isDesktop ? Section3Feature2Img : MobileSection3Feature2Img}
										shadow
									/>
								</FeatureCard>
								<FeatureCard>
									<FeatureNumber>03</FeatureNumber>
									<FeatureTitle>포토 리뷰</FeatureTitle>
									<FeatureDescription>
										긍정 비율이 가장 높은 요소의
										<br />
										포토 리뷰를 모아 보여줍니다.
									</FeatureDescription>
									<FeatureImage
										src={isDesktop ? Section3Feature3Img : MobileSection3Feature3Img}
										shadow
									/>
								</FeatureCard>
							</FeatureContainer>
						</Content>
					</Section>
					<Section backgroundColor={'#F7F9FB'} paddingBottom={isDesktop ? '' : '132px'}>
						<Content>
							<SectionTitle>
								다양한 기능의 관리자페이지로
								<br />
								대표님들의 매출 향상에 기여합니다
							</SectionTitle>
							<FeatureContainer>
								<FeatureCard>
									<FeatureNumber>01</FeatureNumber>
									<FeatureTitle>긍정/부정 요소</FeatureTitle>
									<FeatureDescription>
										<Desktop>
											상품의 긍정, 부정 요소를 리스트에서 한눈에 확인할 수 있습니다.
										</Desktop>
										<Mobile>
											상품의 긍정, 부정 요소를
											<br />
											리스트에서 한눈에
											<br />
											확인할 수 있습니다.
										</Mobile>
									</FeatureDescription>
									<FeatureImage
										src={isDesktop ? Section4Feature1Img : MobileSection4Feature1Img}
										shadow
									/>
								</FeatureCard>
								<FeatureCard>
									<FeatureNumber>02</FeatureNumber>
									<FeatureTitle>분석 리포트</FeatureTitle>
									<FeatureDescription>
										<Desktop>매출이 얼마나 올랐을까요? 매일 분석 리포트를 보내드립니다.</Desktop>
										<Mobile>
											매출이 얼마나 올랐을까요?
											<br />
											매일 분석 리포트를 보내드립니다.
										</Mobile>
									</FeatureDescription>
									<FeatureImage
										src={isDesktop ? Section4Feature2Img : MobileSection4Feature2Img}
										imageWidth={isDesktop ? '520px' : '220px'}
										shadow
									/>
								</FeatureCard>
								<FeatureCard>
									<FeatureNumber>03</FeatureNumber>
									<FeatureTitle>위젯 컬러 설정</FeatureTitle>
									<FeatureDescription>
										<Desktop>
											운영하고 계신 몰의 분위기에 맞게, 다양하고 미세한 컬러 조정이 가능합니다.
										</Desktop>
										<Mobile>
											운영하고 계신 몰의 분위기에 맞게
											<br />
											다양하고 미세한 컬러 조정이 가능합니다.
										</Mobile>
									</FeatureDescription>
									<FeatureImage
										src={isDesktop ? Section4Feature3Img : MobileSection4Feature3Img}
										imageWidth={isDesktop ? '528px' : '270px'}
									/>
								</FeatureCard>
							</FeatureContainer>
						</Content>
					</Section>
					<Section backgroundColor={'#002a51'}>
						<Content>
							<SectionTitle color={'white'}>리뷰에이드에 대해 더 궁금하시다면</SectionTitle>
							<ContactButtonContainer>
                                <ContactButton2 onClick={() => window.open('https://onmydev.notion.site/User-Guide-205364356274456ca4f76d2cf71ad45a')}>
                                    설치 및 이용 가이드
                                </ContactButton2>
                                <EmptyMargin></EmptyMargin>
                                <BrochureButton onClick={() => window.open('https://onmydev-video.s3.ap-northeast-2.amazonaws.com/reviewaid_brochure.pdf')}>
                                    제품 소개서 다운로드
                                </BrochureButton>
							</ContactButtonContainer>
						</Content>
					</Section>
				</Container>
			</Layout>
		)
	);
};

const TopCarouselTitle = styled.div`
	margin-top: 40px;
	text-align: center;
	color: white;

	@media only screen and (min-width: 768px) {
		font-size: 42px;
		font-weight: 700;
		line-height: 42px;
	}

	@media only screen and (max-width: 767.98px) {
		font-size: 24px;
		font-weight: 700;
		line-height: 36px;
	}
`;

const TopLogo = styled.img`
	@media only screen and (min-width: 768px) {
		margin-top: 32px;
		width: 351px;
		height: auto;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 16px;
		width: 158px;
		height: auto;
	}
`;

const TopButtonContainer = styled.div`
	display: flex;

	@media only screen and (min-width: 768px) {
		margin-top: 59px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 30px;
	}
`;

const TopButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: black;
	box-sizing: border-box;
	border: none;

	color: white;
	cursor: pointer;

	a {
		color: white;
	}

	@media only screen and (min-width: 768px) {
		padding: 30px;
		height: 84px;
		border-radius: 10px;

		font-size: 24px;
		font-weight: 700;
		line-height: 24px;

		& + & {
			margin-left: 30px;
		}
	}

	@media only screen and (max-width: 767.98px) {
		padding: 14px 20px;
		height: 42px;
		border-radius: 5px;

		font-size: 14px;
		font-weight: 700;
		line-height: 14px;

		& + & {
			margin-left: 16px;
		}
	}
`;

const TopReviewaid = styled.img`
	@media only screen and (min-width: 768px) {
		margin-top: 80px;
		margin-bottom: 40px;
		width: 700px;
		height: auto;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 50px;
		margin-bottom: 40px;
		width: 300px;
		height: auto;
	}
`;

const StyledSpan = styled.span`
	color: ${(props) => props.color};
`;

const Section2ButtonContainer = styled.div`
	display: flex;

	@media only screen and (min-width: 768px) {
		margin-top: 70px;
		margin-bottom: 80px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 40px;
		margin-bottom: 40px;
	}
`;

const Section2Button = styled.div`
	display: flex;
	background-color: white;
	box-sizing: border-box;
	color: black;

	@media only screen and (min-width: 768px) {
		padding: 30px;
		height: 84px;
		border-radius: 10px;

		font-size: 28px;
		font-weight: 700;
		line-height: 24px;

		& + & {
			margin-left: 80px;
		}
	}

	@media only screen and (max-width: 767.98px) {
		padding: 12px 18px;
		height: 38px;
		border-radius: 5px;

		font-size: 14px;
		font-weight: 700;
		line-height: 14px;

		& + & {
			margin-left: 17px;
		}
	}
`;

const Section2ButtonArrow = styled.div`
	display: inline-flex;
	background-size: cover;

	@media only screen and (min-width: 768px) {
		margin-left: 12px;
		width: 15px;
		height: 25px;
		background-image: url(${Section2ButtonArrowImg});
	}

	@media only screen and (max-width: 767.98px) {
		margin-left: 6px;
		width: 8px;
		height: 14px;
		background-image: url(${MobileSection2ButtonArrowImg});
	}
`;

const FeatureContainer = styled.div`
	@media only screen and (min-width: 768px) {
		margin-top: 70px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 40px;
	}
`;

const ContactButtonContainer = styled.div`
	display: flex;

	@media only screen and (min-width: 768px) {
        flex-direction: row;
	}

	@media only screen and (max-width: 767.98px) {
        flex-direction: column;
	}
`;

const EmptyMargin = styled.div`
    width: 30px;
`;

export default Reviewaid;
